import { render, staticRenderFns } from "./studentManageMentAdd.vue?vue&type=template&id=674774f3&scoped=true&"
import script from "./studentManageMentAdd.vue?vue&type=script&lang=js&"
export * from "./studentManageMentAdd.vue?vue&type=script&lang=js&"
import style0 from "./studentManageMentAdd.vue?vue&type=style&index=0&id=674774f3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674774f3",
  null
  
)

export default component.exports